import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    padding: theme.spacing(2, 3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1.5),
      padding: theme.spacing(1.5, 2),
    },
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  pillsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    minWidth: 0,
    flex: 1,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  pillsScroll: {
    display: 'flex',
    gap: theme.spacing(1.25),
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    minWidth: 0,
    padding: theme.spacing(0.5, 0),
    '& .MuiButton-root': { flexShrink: 0, whiteSpace: 'nowrap' },
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) },
    },
  },
  addButton: {
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      '& .MuiButton-root': { width: '100%' },
    },
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiButton-root': { minHeight: theme.spacing(5.5) },
    },
  },
}));
